var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationalProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8501_22362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 22,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 13.0832H9.25V11.2499H4.66667V13.0832ZM4.66667 16.7499H8.33333V14.9166H4.66667V16.7499ZM4.66667 9.41657H9.25V7.58324H4.66667V9.41657ZM14.75 13.0832H18.4167V11.2499H14.75V13.0832ZM14.75 16.7499H19.3333V14.9166H14.75V16.7499ZM14.75 9.41657H19.3333V7.58324H14.75V9.41657ZM21.1667 19.5H14.75L12.9167 20.4167V5.75L14.75 4.83333H21.1667V19.5ZM11.0833 20.4167L9.25 19.5H2.83333V4.83333H9.25L11.0833 5.75V20.4167ZM14.75 3L12.9167 3.91667H11.0833L9.25 3L1 3.01833V21.3333L1.01833 21.315L9.25 21.3333L11.0833 22.25H12.9167L14.75 21.3333L22.9817 21.315L23 21.3333V3.01833L14.75 3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8501_22362)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationalProgram);
export default __webpack_public_path__ + "static/media/EducationalProgram.d50761df1e62e5ab3bd625fb4545db47.svg";
export { ForwardRef as ReactComponent };